import { render } from "./header.layout.vue?vue&type=template&id=5289f8b0"
import script from "./header.layout.vue?vue&type=script&lang=js"
export * from "./header.layout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__